import React from 'react';
import { CopyBlock } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './ReviewsPolicy.styles';

export const ReviewsPolicy = () => {
  return (
    <div css={styles.container}>
      <CopyBlock alignment="center">
        <p>
          Read our customer <a href="/about/reviews-policy">reviews policy</a>
        </p>
      </CopyBlock>
    </div>
  );
};
